module.exports = __webpack_public_path__ + "static/img/05chahua3.711ab46.png";


//////////////////
// WEBPACK FOOTER
// ./src/apps/zcx/assets/images/05chahua3.png
// module id = 37/m
// module chunks = 7